export default __webpack_public_path__ + "static/banner-mobile-tampons-2-f5aaf64c168a32005227ed9a4f8ede5f.png";